(function () {
  if (window.__onlyOneFacetDetailsOpen) return;
  window.__onlyOneFacetDetailsOpen = true;

  function hydrateObfuscatedLinks(root) {
    try {
      var scope = root && root.querySelectorAll ? root : document;
      scope.querySelectorAll('a.smala-obf-link[data-href]:not([href])').forEach(function (anchor) {
        var target = anchor.getAttribute('data-href');
        if (target) {
          anchor.setAttribute('href', target);
        }
      });
    } catch (e) { /* noop */ }
  }

  function handleObfuscatedSortLinks() {
    try {
      var scope = document;
      scope.querySelectorAll('a.smala-obf-link[data-href]').forEach(function (anchor) {
        // Ignorer les liens avec target="_blank" (réseaux sociaux, etc.) - ils sont gérés par hydrateObfuscatedLinks
        if (anchor.getAttribute('target') === '_blank') {
          return;
        }
        anchor.addEventListener('click', function (event) {
          event.preventDefault();
          var target = this.getAttribute('data-href');
          if (target) {
            // Utiliser l'API de navigation du navigateur pour éviter les problèmes de cache
            window.location.href = target;
          }
        });
      });
    } catch (e) { /* noop */ }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      hydrateObfuscatedLinks(document);
      handleObfuscatedSortLinks();
    }, { once: true });
  } else {
    hydrateObfuscatedLinks(document);
    handleObfuscatedSortLinks();
  }

  document.addEventListener('shopify:section:load', function (event) {
    hydrateObfuscatedLinks(event.target);
    handleObfuscatedSortLinks();
  });
  document.addEventListener('shopify:section:select', function (event) {
    hydrateObfuscatedLinks(event.target);
    handleObfuscatedSortLinks();
  });
  document.addEventListener('shopify:section:reorder', function (event) {
    hydrateObfuscatedLinks(event.target);
    handleObfuscatedSortLinks();
  });

  // Délégation: garde un seul <details> ouvert dans .collection__filters-selects,
  // même après les mises à jour AJAX des facettes
  document.addEventListener('toggle', function (event) {
    const details = event.target;
    if (!(details instanceof HTMLDetailsElement)) return;

    const container = details.closest('.collection__filters-selects');
    if (!container) return;

    if (details.open) {
      // Fermer les autres <details> en cliquant sur leur <summary>
      // (pour laisser le composant accordion-disclosure et le thème garder l'état en phase)
      container.querySelectorAll('details').forEach(function (other) {
        if (other !== details && other.open) {
          const summary = other.querySelector('summary');
          if (summary) summary.click();
        }
      });
    }
  }, true);

  // Ferme tout <details> ouvert lorsqu'on clique en dehors d'un <details>
  document.addEventListener('click', function (event) {
    const target = event.target;
    const container = document.querySelector('.collection__filters-selects');
    if (!container) return;

    // Si le clic se produit à l'intérieur d'un <details> du conteneur, ne rien faire
    if (target.closest('.collection__filters-selects details')) return;
    // Si le clic se produit dans le portail mobile, ne rien faire
    if (target.closest('[data-accordion-portal]')) return;

    // Sinon, fermer tous les <details> ouverts proprement via leur <summary>
    container.querySelectorAll('details[open]').forEach(function (openDetails) {
      const summary = openDetails.querySelector('summary');
      if (summary) summary.click();
    });
  }, true);

  // Portail mobile: déplace le .accordion__content dans <body> pour éviter les problèmes d'overflow
  const mql = window.matchMedia('(max-width: 1000px)');
  let activePortal = null; // { details, content, parent, nextSibling, container, scroller, previousDisplay }

  function isMobileViewport() {
    return mql.matches;
  }

  function updatePortalPosition(details, container) {
    const summary = details.querySelector('summary');
    if (!summary) return;

    const rect = summary.getBoundingClientRect();

    // Positionne juste sous le <summary> et aligne la largeur
    const top = Math.max(0, rect.bottom);
    const left = Math.max(0, rect.left);
    const width = Math.min(window.innerWidth - left, rect.width);
    const maxHeight = Math.max(120, window.innerHeight - top - 8);

    container.style.position = 'fixed';
    container.style.top = top + 8 + 'px';
    container.style.maxHeight = maxHeight + 'px';
    container.style.overflow = 'auto';
    container.style.zIndex = '3';
    container.style.margin = '0';
    container.style.padding = '0';
    container.style.background = 'transparent';
  }

  function portalDetails(details) {
    // Recrée systématiquement le portail à chaque ouverture
    if (activePortal) {
      try { unportalDetails(activePortal.details); } catch (e) { }
    }

    const content = details.querySelector(':scope > .accordion__content');
    if (!content) return;

    const parent = content.parentNode;
    const nextSibling = content.nextSibling;
    const container = document.createElement('div');
    container.setAttribute('data-accordion-portal', '');
    container.classList.add('color-scheme--scheme-1');

    // Force l'affichage au cas où le CSS dépend de [open]
    const previousDisplay = content.style.display;
    content.style.display = 'block';

    container.appendChild(content);
    const portalRoot = details.closest('main') || document.body;
    portalRoot.appendChild(container);

    updatePortalPosition(details, container);

    const scroller = details.closest('.collection__filters-selects');
    const facetsForm = details.closest('facets-form');
    activePortal = { details, content, parent, nextSibling, container, previousDisplay, scroller, facetsForm };

    // Associer les inputs déplacés au formulaire d'origine via l'attribut form
    const form = details.closest('form');
    if (form && form.id) {
      container.querySelectorAll('input, select, textarea, button').forEach(function (el) {
        try {
          el.setAttribute('form', form.id);
        } catch (e) { }
      });
    }

    // Pont d'événements: propage les changements vers <facets-form>
    try {
      const bridgeChange = function () {
        if (!activePortal || !activePortal.facetsForm) return;
        // Déclenche le flux AJAX de facets-form (update-on-change ou fetch)
        activePortal.facetsForm.dispatchEvent(new Event('change', { bubbles: true }));
      };
      container.addEventListener('change', bridgeChange);
      activePortal.bridgeChange = bridgeChange;
    } catch (e) { }
  }

  function unportalDetails(details) {
    if (!activePortal || activePortal.details !== details) return;
    const { content, parent, nextSibling, container, previousDisplay, scroller } = activePortal;

    // Restaure le contenu à sa position d'origine
    if (nextSibling && nextSibling.parentNode === parent) {
      parent.insertBefore(content, nextSibling);
    } else if (parent) {
      parent.appendChild(content);
    }

    // Nettoyage
    if (container && container.parentNode) container.parentNode.removeChild(container);
    content.style.display = previousDisplay || '';
    if (scroller) {
      try { scroller.removeEventListener('scroll', syncActivePortal); } catch (e) { }
    }
    // Retire le pont d'événements
    try {
      if (activePortal && activePortal.bridgeChange && container) {
        container.removeEventListener('change', activePortal.bridgeChange);
      }
    } catch (e) { }
    activePortal = null;
  }

  function forceCleanup() {
    if (activePortal && activePortal.details) {
      try { unportalDetails(activePortal.details); } catch (e) { }
    }
    // Supprime tout conteneur orphelin restant (au cas où le DOM a été remplacé)
    document.querySelectorAll('[data-accordion-portal]').forEach(function (node) {
      try { node.parentNode && node.parentNode.removeChild(node); } catch (e) { }
    });
  }

  // Garde la position à jour pendant le scroll/resize
  function isSummaryInViewport(details) {
    const summary = details && details.querySelector('summary');
    if (!summary) return false;
    const rect = summary.getBoundingClientRect();
    return rect.bottom > 0 && rect.top < window.innerHeight;
  }

  function syncActivePortal() {
    if (!activePortal) return;
    if (!activePortal.details.open) { unportalDetails(activePortal.details); return; }
    if (!isMobileViewport()) { unportalDetails(activePortal.details); return; }

    // Ferme si le <summary> n'est plus visible verticalement
    if (!isSummaryInViewport(activePortal.details)) { unportalDetails(activePortal.details); return; }

    updatePortalPosition(activePortal.details, activePortal.container);
  }

  window.addEventListener('scroll', syncActivePortal, { passive: true });
  window.addEventListener('resize', syncActivePortal);
  window.addEventListener('visibilitychange', function () { if (document.hidden) forceCleanup(); });
  window.addEventListener('pagehide', forceCleanup);
  window.addEventListener('beforeunload', forceCleanup);
  window.addEventListener('popstate', forceCleanup);
  window.addEventListener('hashchange', syncActivePortal);
  mql.addEventListener('change', function () {
    // Si on quitte le mobile, on restaure
    if (!isMobileViewport() && activePortal && activePortal.details) {
      unportalDetails(activePortal.details);
    } else {
      syncActivePortal();
    }
  });

  // Active le portail sur les accordéons des facettes en mobile
  document.addEventListener('toggle', function (event) {
    const details = event.target;
    if (!(details instanceof HTMLDetailsElement)) return;

    const container = details.closest('.collection__filters-selects');
    if (!container) return;

    if (details.open && isMobileViewport()) {
      portalDetails(details);
      if (activePortal && activePortal.scroller) {
        try { activePortal.scroller.addEventListener('scroll', syncActivePortal, { passive: true }); } catch (e) { }
      }
    } else {
      unportalDetails(details);
    }
  }, true);

  // Nettoyage robuste quand le DOM des facettes est remplacé (mises à jour AJAX)
  const mutationObserver = new MutationObserver(function () {
    if (activePortal && (!activePortal.details || !activePortal.details.isConnected || !activePortal.details.closest('.collection__filters-selects'))) {
      forceCleanup();
    }
  });
  try { mutationObserver.observe(document.documentElement, { childList: true, subtree: true }); } catch (e) { }
})();


// cart drawer ===================================================================================================================================================

// cart drawer coffret
var CoffretForm = class extends HTMLElement {
  constructor() {
    super();
    this.updateTimeout = null;
    this.changeHandler = null;
    this.isUpdating = false;
  }

  connectedCallback() {
    // Gestion des événements avec debounce
    this.changeHandler = () => {
      this.scheduleUpdate(300);
    };
    this.addEventListener("change", this.changeHandler);
    
    // Gestion de l'affichage/masquage de la section mot personnalisé
    this.toggleNoteSection();
    const coffretCheckbox = this.querySelector("input[name='attributes[coffret-checked]']");
    if (coffretCheckbox) {
      this.coffretCheckboxHandler = () => {
        this.toggleNoteSection();
      };
      coffretCheckbox.addEventListener("change", this.coffretCheckboxHandler);
    }
    
    // Gestion de l'affichage/masquage du formulaire de note
    this.toggleNoteForm();
    const noteCheckbox = this.querySelector("input[name='attributes[coffret-note-checked]']");
    if (noteCheckbox) {
      this.noteCheckboxHandler = () => {
        this.toggleNoteForm();
      };
      noteCheckbox.addEventListener("change", this.noteCheckboxHandler);
    }
  }
  
  toggleNoteSection() {
    const coffretCheckbox = this.querySelector("input[name='attributes[coffret-checked]']");
    const noteSection = this.querySelector(".coffret-note-section");
    
    if (coffretCheckbox && noteSection) {
      if (coffretCheckbox.checked) {
        noteSection.style.display = "";
      } else {
        noteSection.style.display = "none";
        // Décocher et vider le mot personnalisé si le coffret est désactivé
        const noteCheckbox = this.querySelector("input[name='attributes[coffret-note-checked]']");
        const noteForm = this.querySelector(".coffret-note-form");
        const noteTextarea = this.querySelector("textarea[name='attributes[coffret-note]']");
        if (noteCheckbox) noteCheckbox.checked = false;
        if (noteForm) noteForm.style.display = "none";
        if (noteTextarea) noteTextarea.value = "";
      }
    }
  }
  
  toggleNoteForm() {
    const noteCheckbox = this.querySelector("input[name='attributes[coffret-note-checked]']");
    const noteForm = this.querySelector(".coffret-note-form");
    
    if (noteCheckbox && noteForm) {
      if (noteCheckbox.checked) {
        noteForm.style.display = "";
      } else {
        noteForm.style.display = "none";
        // Vider le textarea si la checkbox est décochée
        const noteTextarea = this.querySelector("textarea[name='attributes[coffret-note]']");
        if (noteTextarea) noteTextarea.value = "";
      }
    }
  }

  disconnectedCallback() {
    // Nettoyage des timeouts et événements
    if (this.updateTimeout) {
      clearTimeout(this.updateTimeout);
      this.updateTimeout = null;
    }
    if (this.changeHandler) {
      this.removeEventListener("change", this.changeHandler);
      this.changeHandler = null;
    }
    if (this.coffretCheckboxHandler) {
      const coffretCheckbox = this.querySelector("input[name='attributes[coffret-checked]']");
      if (coffretCheckbox) {
        coffretCheckbox.removeEventListener("change", this.coffretCheckboxHandler);
      }
      this.coffretCheckboxHandler = null;
    }
    if (this.noteCheckboxHandler) {
      const noteCheckbox = this.querySelector("input[name='attributes[coffret-note-checked]']");
      if (noteCheckbox) {
        noteCheckbox.removeEventListener("change", this.noteCheckboxHandler);
      }
      this.noteCheckboxHandler = null;
    }
  }

  scheduleUpdate(delay = 300) {
    // Ne planifie pas d'update si déjà en cours
    if (this.isUpdating) {
      return;
    }

    // Annule la mise à jour précédente si elle n'a pas encore eu lieu
    if (this.updateTimeout) {
      clearTimeout(this.updateTimeout);
    }

    // Programme une nouvelle mise à jour avec délai
    this.updateTimeout = setTimeout(() => {
      this.update();
      this.updateTimeout = null;
    }, delay);
  }

  async update() {
    // Empêche les updates concurrents
    if (this.isUpdating) {
      return;
    }

    this.isUpdating = true;

    const id = window.coffret.product_variant_id;
    const coffretChecked = this.querySelector("input[name='attributes[coffret-checked]']").checked;
    const coffretNoteChecked = this.querySelector("input[name='attributes[coffret-note-checked]']").checked;
    const coffretNote = this.querySelector("textarea[name='attributes[coffret-note]']").value;

    window.coffret.coffretChecked = coffretChecked;
    window.coffret.coffretNoteChecked = coffretNoteChecked;
    window.coffret.coffretNote = coffretNote;

    try {
      document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));

      const data = {
        attributes: {
          'coffret-checked': coffretChecked,
          'coffret-note-checked': coffretNoteChecked,
          'coffret-note': coffretNote,
          'coffret-id': id,
          'coffret-quantity': 1,
        },
        updates: {
          [id]: coffretChecked ? 1 : 0
        }
      };

      const response = await fetch(`${Shopify.routes.root}cart/update.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data)
      });

      if (response.ok) {
        // Force un refresh complet du cart drawer pour mettre à jour les prix
        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
      } else {
        console.error('[CoffretForm] Cart update failed:', response.status);
      }

      document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
    } catch (error) {
      console.error('[CoffretForm] Error updating cart:', error);
      document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
    } finally {
      this.isUpdating = false;
    }
  }
}
if (!window.customElements.get("coffret-form")) {
  window.customElements.define("coffret-form", CoffretForm);
}

// cart drawer super smala
var SuperSmalaForm = class extends HTMLElement {
  constructor() {
    super();
    this.updateTimeout = null;
    this.changeHandler = null;
    this.isUpdating = false;
  }

  connectedCallback() {
    // Gestion des événements avec debounce
    this.changeHandler = () => {
      this.scheduleUpdate(300);
    };
    this.addEventListener("change", this.changeHandler);
  }

  disconnectedCallback() {
    // Nettoyage des timeouts et événements
    if (this.updateTimeout) {
      clearTimeout(this.updateTimeout);
      this.updateTimeout = null;
    }
    if (this.changeHandler) {
      this.removeEventListener("change", this.changeHandler);
      this.changeHandler = null;
    }
  }

  scheduleUpdate(delay = 300) {
    // Ne planifie pas d'update si déjà en cours
    if (this.isUpdating) {
      return;
    }

    // Annule la mise à jour précédente si elle n'a pas encore eu lieu
    if (this.updateTimeout) {
      clearTimeout(this.updateTimeout);
    }

    // Programme une nouvelle mise à jour avec délai
    this.updateTimeout = setTimeout(() => {
      this.update();
      this.updateTimeout = null;
    }, delay);
  }

  async update() {
    // Empêche les updates concurrents
    if (this.isUpdating) {
      return;
    }

    this.isUpdating = true;

    const id = window.super_smala.product_variant_id;
    const sellingPlanId = window.super_smala.selling_plan_id;
    const superSmalaChecked = this.querySelector("input[name='attributes[super-smala-checked]']").checked;

    window.super_smala.superSmalaChecked = superSmalaChecked;

    try {
      document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));

      // Si on coche et qu'il y a un selling plan, on doit d'abord retirer puis ajouter avec le selling plan
      if (superSmalaChecked && sellingPlanId) {
        // D'abord on s'assure que le produit n'est pas déjà dans le panier
        // On récupère le panier actuel pour trouver le line item
        const cartResponse = await fetch(`${Shopify.routes.root}cart.js`);
        const cart = await cartResponse.json();
        const existingItem = cart.items.find(item => item.variant_id == id);
        
        if (existingItem) {
          // On retire le produit existant
          await fetch(`${Shopify.routes.root}cart/change.js`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              id: existingItem.key,
              quantity: 0
            })
          });
        }

        // Ensuite on ajoute avec le selling plan
        const addResponse = await fetch(`${Shopify.routes.root}cart/add.js`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            items: [{
              id: id,
              quantity: 1,
              selling_plan: sellingPlanId
            }]
          })
        });

        if (addResponse.ok) {
          // Met à jour les attributs
          await fetch(`${Shopify.routes.root}cart/update.js`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              attributes: {
                'super-smala-checked': true,
                'super-smala-id': id,
                'super-smala-quantity': 1,
                'super-smala-selling-plan': sellingPlanId
              }
            })
          });
        }
      } else {
        // Pas de selling plan ou décochage
        if (superSmalaChecked) {
          // Ajout au panier
          const addResponse = await fetch(`${Shopify.routes.root}cart/add.js`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              items: [{
                id: id,
                quantity: 1
              }]
            })
          });

          if (addResponse.ok) {
            // Met à jour les attributs
            await fetch(`${Shopify.routes.root}cart/update.js`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                attributes: {
                  'super-smala-checked': true,
                  'super-smala-id': id,
                  'super-smala-quantity': 1
                }
              })
            });
          } else {
            console.error('[SuperSmalaForm] Cart add failed:', addResponse.status);
          }
        } else {
          // Retrait du panier - on doit trouver le line item
          const cartResponse = await fetch(`${Shopify.routes.root}cart.js`);
          const cart = await cartResponse.json();
          const existingItem = cart.items.find(item => item.variant_id == id);
          
          if (existingItem) {
            const changeResponse = await fetch(`${Shopify.routes.root}cart/change.js`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                id: existingItem.key,
                quantity: 0
              })
            });

            if (changeResponse.ok) {
              // Met à jour les attributs
              await fetch(`${Shopify.routes.root}cart/update.js`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  attributes: {
                    'super-smala-checked': false,
                    'super-smala-id': '',
                    'super-smala-quantity': 0
                  }
                })
              });
            } else {
              console.error('[SuperSmalaForm] Cart change failed:', changeResponse.status);
            }
          }
        }
      }

      // Force un refresh complet du cart drawer pour mettre à jour les prix
      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
      document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
    } catch (error) {
      console.error('[SuperSmalaForm] Error updating cart:', error);
      document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
    } finally {
      this.isUpdating = false;
    }
  }
}
if (!window.customElements.get("super-smala-form")) {
  window.customElements.define("super-smala-form", SuperSmalaForm);
}

// cart drawer cadeau
var CadeauForm = class extends HTMLElement {
  constructor() {
    super();
    this.updateTimeout = null;
    this.cartChangeHandler = null;
  }

  connectedCallback() {
    // Délai initial plus long car ce composant dépend de l'état du panier
    this.scheduleUpdate(800);

    // Écoute les changements du panier (événement personnalisé Shopify)
    this.cartChangeHandler = () => {
      this.scheduleUpdate(500);
    };
    document.addEventListener("cart:change", this.cartChangeHandler);
  }

  disconnectedCallback() {
    // Nettoyage des timeouts et événements
    if (this.updateTimeout) {
      clearTimeout(this.updateTimeout);
      this.updateTimeout = null;
    }
    if (this.cartChangeHandler) {
      document.removeEventListener("cart:change", this.cartChangeHandler);
      this.cartChangeHandler = null;
    }
  }

  scheduleUpdate(delay = 500) {
    // Annule la mise à jour précédente si elle n'a pas encore eu lieu
    if (this.updateTimeout) {
      clearTimeout(this.updateTimeout);
    }

    // Programme une nouvelle mise à jour avec délai
    this.updateTimeout = setTimeout(() => {
      this.update();
      this.updateTimeout = null;
    }, delay);
  }

  async update() {
    // Vérifier que window.cadeau est défini avant de continuer
    if (!window.cadeau || !window.cadeau.product_variant_id || !window.cadeau.price_limit) {
      return;
    }

    const response = await fetch(`${Shopify.routes.root}cart.js`, {
      method: "GET"
    });
    const cart = await response.json();

    const id = window.cadeau.product_variant_id;
    const priceLimit = window.cadeau.price_limit;
    const cadeauOk = cart.total_price >= priceLimit;

    const data = {
      attributes: {
        'cadeau-id': id,
        'cadeau-quantity': 1,
      },
      updates: {
        [id]: cadeauOk ? 1 : 0
      }
    };
    fetch(`${Shopify.routes.root}cart/update.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
      keepalive: true
    });
  }
}
if (!window.customElements.get("cadeau-form")) {
  window.customElements.define("cadeau-form", CadeauForm);
}

// tabs component ===================================================================================================================================================
class TabsComponent extends HTMLElement {
  constructor() {
    super();
    this.buttons = [];
    this.panels = [];
  }

  connectedCallback() {
    // Récupère tous les boutons et panneaux
    this.buttons = Array.from(this.querySelectorAll('.smala-tabs__button'));
    this.panels = Array.from(this.querySelectorAll('.smala-tabs__panel'));

    // Ajoute les event listeners sur les boutons
    this.buttons.forEach(button => {
      button.addEventListener('click', (e) => this.handleTabClick(e));
    });

    // Assure qu'au moins un onglet est actif au démarrage
    this.ensureActiveTab();
  }

  disconnectedCallback() {
    // Nettoyage des event listeners
    this.buttons.forEach(button => {
      button.removeEventListener('click', (e) => this.handleTabClick(e));
    });
  }

  handleTabClick(event) {
    const button = event.currentTarget;
    const tabIndex = button.getAttribute('data-tab');

    // Active le bon onglet
    this.activateTab(tabIndex);
  }

  activateTab(tabIndex) {
    // Désactive tous les boutons et panneaux
    this.buttons.forEach(btn => btn.classList.remove('active'));
    this.panels.forEach(panel => panel.classList.remove('active'));

    // Active le bouton et le panneau correspondants
    const activeButton = this.querySelector(`[data-tab="${tabIndex}"]`);
    const activePanel = this.querySelector(`[data-panel="${tabIndex}"]`);

    if (activeButton) activeButton.classList.add('active');
    if (activePanel) {
      activePanel.classList.add('active');

      // Animation fade-in
      activePanel.style.opacity = '0';
      requestAnimationFrame(() => {
        activePanel.style.transition = 'opacity 0.3s ease';
        activePanel.style.opacity = '1';
      });
    }
  }

  ensureActiveTab() {
    // Si aucun onglet n'est actif, active le premier
    const hasActiveButton = this.buttons.some(btn => btn.classList.contains('active'));
    if (!hasActiveButton && this.buttons.length > 0) {
      this.activateTab('0');
    }
  }
}

if (!window.customElements.get("tabs-component")) {
  window.customElements.define("tabs-component", TabsComponent);
}

// Cart Timer Element - Simplifié et optimisé
class CartTimerElement extends HTMLElement {
  static STORAGE_KEYS = {
    START_TIME: 'cart_timer_start',
    DURATION: 'cart_timer_duration',
    DURATION_WARNING: 'cart_timer_duration_warning',
    MODAL_SHOWN: 'cart_timer_modal_shown'
  };

  static DEFAULTS = {
    DURATION_MINUTES: 5,
    MESSAGE: 'Votre panier expire dans',
    POPUP_TITLE: 'Oups ! Votre panier va expirer !',
    POPUP_MESSAGE: '<p>Les articles sont réservés pendant [remaining_time] dans votre panier.</p>',
    UPDATE_INTERVAL_MS: 1000
  };

  constructor() {
    super();
    this.interval = null;
    this.modal = null;
    this.startTime = null;
    this.durationSeconds = 0;
    this.durationWarningSeconds = 0;
    this.currentCartItemCount = 0;
    this.modalShown = false;
  }

  connectedCallback() {
    this.durationSeconds = this._parseDuration();
    this.durationWarningSeconds = this._parseDurationWarning();
    
    this.createModal();
    this.setupModalListeners();
    this.listenToCartEvents();
    this.initTimer();
  }

  disconnectedCallback() {
    this._cleanup();
  }

  // ===== INITIALIZATION =====

  _parseDuration() {
    const duration = parseInt(this.dataset.duration, 10);
    return (isNaN(duration) || duration <= 0) 
      ? CartTimerElement.DEFAULTS.DURATION_MINUTES * 60 
      : duration * 60;
  }

  _parseDurationWarning() {
    const warning = parseInt(this.dataset.durationWarning, 10);
    return (isNaN(warning) || warning <= 0) ? 0 : warning;
  }

  createModal() {
    const existingModal = document.getElementById('cart-timer-modal');
    if (existingModal) {
      this.modal = existingModal;
      return;
    }

    const modalHTML = `
      <x-modal id="cart-timer-modal" append-to-body class="modal modal--tight color-scheme color-scheme--scheme-1">
        <div class="cart-timer-modal__content prose prose-justify-center">
          <p class="h5 cart-timer-modal__title"></p>
          <div class="text-start cart-timer-modal__message"></div>
          <div class="cart-timer-modal__actions">
            <button type="button" class="button cart-timer-modal__checkout"></button>
          </div>
        </div>
      </x-modal>
    `;

    document.body.insertAdjacentHTML('beforeend', modalHTML);
    this.modal = document.getElementById('cart-timer-modal');
  }

  setupModalListeners() {
    if (!this.modal) return;
    
    // Évite d'ajouter plusieurs fois les event listeners si la modal existe déjà
    if (this.modal.hasAttribute('data-listeners-attached')) {
      // Réattacher les handlers aux boutons pour cette instance
      this._attachButtonHandlers();
      return;
    }
    
    this.modal.setAttribute('data-listeners-attached', 'true');
    this._attachButtonHandlers();
    
    // Stocker une référence à l'instance courante sur la modal
    // pour que le handler dialog:after-hide puisse y accéder
    this.modal._cartTimerInstance = this;
    
    // Si l'utilisateur ferme la modal, on ne la réaffiche pas
    this.modal.addEventListener('dialog:after-hide', () => {
      const instance = this.modal._cartTimerInstance;
      if (!instance) return;
      
      instance.modalShown = true;
      instance._saveTimerState(instance.startTime, instance.durationSeconds);
    });
  }
  
  _attachButtonHandlers() {
    const checkoutBtn = this.modal.querySelector('.cart-timer-modal__checkout');

    // Cloner et remplacer le bouton pour supprimer les anciens event listeners
    if (checkoutBtn) {
      const newCheckoutBtn = checkoutBtn.cloneNode(true);
      checkoutBtn.parentNode.replaceChild(newCheckoutBtn, checkoutBtn);
      newCheckoutBtn.addEventListener('click', () => this.handleCheckout());
    }
    
    // Mettre à jour la référence de l'instance
    this.modal._cartTimerInstance = this;
  }

  async initTimer() {
    const cart = await this._fetchCart();
    if (cart) {
      this.currentCartItemCount = cart.item_count;
    }

    const savedState = this._loadTimerState();

    if (savedState) {
      this.startTime = savedState.startTime;
      this.durationSeconds = savedState.duration;
      this.modalShown = savedState.modalShown;

      const remaining = this._getRemainingSeconds();

      if (remaining > 0 && this.currentCartItemCount > 0) {
        this.startInterval();
      } else {
        this._clearTimerState();
      }
    } else if (this.currentCartItemCount > 0) {
      this.startTimer();
    }
  }

  listenToCartEvents() {
    this.cartEventListener = (event) => {
      if (event.detail?.cart) {
        this.handleCartUpdate(event.detail.cart);
      }
    };

    document.documentElement.addEventListener('cart:change', this.cartEventListener);
  }

  // ===== TIMER CONTROL =====

  startTimer() {
    if (this.currentCartItemCount === 0) return;

    this.startTime = Date.now();
    this.modalShown = false; // Reset flag for new timer
    this._saveTimerState(this.startTime, this.durationSeconds);
    this.startInterval();
  }

  resetTimer() {
    if (this.currentCartItemCount === 0) {
      this.stopTimer();
      return;
    }

    this.stopTimer();
    this.startTimer();
  }

  stopTimer() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }

  startInterval() {
    this.updateDisplay();

    this.interval = setInterval(() => {
      const remaining = this._getRemainingSeconds();

      if (remaining <= 0) {
        this.stopTimer();
        this._clearTimerState();
        return;
      }
      
      // Afficher la modal d'avertissement une seule fois (quand remaining est entre 0 et warningThreshold)
      if (this.durationWarningSeconds > 0 && !this.modalShown) {
        const warningThreshold = this.durationWarningSeconds * 60;
        if (remaining > 0 && remaining <= warningThreshold && this.modal && !this.modal.hasAttribute('open')) {
          this.showWarningModal();
          this.modalShown = true;
          this._saveTimerState(this.startTime, this.durationSeconds);
        }
      }
      this.updateDisplay();
    }, CartTimerElement.DEFAULTS.UPDATE_INTERVAL_MS);
  }

  updateDisplay() {
    const remaining = this._getRemainingSeconds();
    const { minutes, seconds } = this._formatTime(remaining);

    const messageEl = this.querySelector('.cart-timer__message');
    const countdownEl = this.querySelector('.cart-timer__countdown');

    if (messageEl) {
      messageEl.textContent = this.dataset.message || CartTimerElement.DEFAULTS.MESSAGE;
    }

    if (countdownEl) {
      countdownEl.textContent = `${minutes}:${seconds.toString().padStart(2, '0')}`;
      
      // Warning visuel basé sur duration_warning ou ratio
      const warningThreshold = this.durationWarningSeconds > 0 
        ? this.durationWarningSeconds * 60 
        : this.durationSeconds / 6;
      
      countdownEl.classList.toggle('cart-timer__countdown--warning', remaining <= warningThreshold);
    }
  }

  // ===== CART HANDLING =====

  handleCartUpdate(cartData) {
    if (!cartData) return;

    const newItemCount = cartData.item_count ?? 0;
    const previousItemCount = this.currentCartItemCount;

    this.currentCartItemCount = newItemCount;

    if (newItemCount > 0 && newItemCount !== previousItemCount) {
      this.resetTimer();
    } else if (newItemCount === 0) {
      this.stopTimer();
      this._clearTimerState();
    }
  }

  async _fetchCart() {
    try {
      const response = await fetch(`${Shopify?.routes?.root || '/'}cart.js`);
      if (!response.ok) return null;
      
      const cart = await response.json();
      return cart && typeof cart.item_count === 'number' ? cart : null;
    } catch (error) {
      console.error('[CartTimer] Error fetching cart:', error);
      return null;
    }
  }

  // ===== MODAL =====

  showWarningModal() {
    if (!this.modal) return;

    const titleEl = this.modal.querySelector('.cart-timer-modal__title');
    const messageEl = this.modal.querySelector('.cart-timer-modal__message');
    const checkoutBtn = this.modal.querySelector('.cart-timer-modal__checkout');

    if (titleEl) {
      titleEl.textContent = this.dataset.popupTitle || CartTimerElement.DEFAULTS.POPUP_TITLE;
    }

    if (messageEl) {
      let message = this.dataset.popupMessage || CartTimerElement.DEFAULTS.POPUP_MESSAGE;
      const remaining = this._getRemainingSeconds();
      const { minutes, seconds } = this._formatTime(remaining);
      const formattedTime = `${minutes}:${seconds.toString().padStart(2, '0')}`;
      message = message.replace('[remaining_time]', formattedTime);
      messageEl.innerHTML = message;
    }

    if (checkoutBtn) {
      checkoutBtn.textContent = this.dataset.checkoutText || 'Aller au checkout';
    }

    this.modal.setAttribute('open', '');
  }

  closeModal() {
    if (this.modal) {
      this.modal.removeAttribute('open');
    }
  }

  // ===== ACTIONS =====

  handleCheckout() {
    this.closeModal();
    this._clearTimerState();
    this.stopTimer();
  }

  // ===== STORAGE =====

  _saveTimerState(startTime, duration) {
    try {
      localStorage.setItem(CartTimerElement.STORAGE_KEYS.START_TIME, startTime.toString());
      localStorage.setItem(CartTimerElement.STORAGE_KEYS.DURATION, duration.toString());
      localStorage.setItem(CartTimerElement.STORAGE_KEYS.DURATION_WARNING, this.durationWarningSeconds.toString());
      localStorage.setItem(CartTimerElement.STORAGE_KEYS.MODAL_SHOWN, this.modalShown ? '1' : '0');
    } catch (e) {}
  }

  _loadTimerState() {
    try {
      const startTime = localStorage.getItem(CartTimerElement.STORAGE_KEYS.START_TIME);
      const duration = localStorage.getItem(CartTimerElement.STORAGE_KEYS.DURATION);

      if (!startTime || !duration) return null;

      const parsedStartTime = parseInt(startTime, 10);
      const parsedDuration = parseInt(duration, 10);

      if (isNaN(parsedStartTime) || isNaN(parsedDuration)) {
        this._clearTimerState();
        return null;
      }

      const modalShown = localStorage.getItem(CartTimerElement.STORAGE_KEYS.MODAL_SHOWN) === '1';

      return { startTime: parsedStartTime, duration: parsedDuration, modalShown };
    } catch (e) {
      return null;
    }
  }

  _clearTimerState() {
    try {
      localStorage.removeItem(CartTimerElement.STORAGE_KEYS.START_TIME);
      localStorage.removeItem(CartTimerElement.STORAGE_KEYS.DURATION);
      localStorage.removeItem(CartTimerElement.STORAGE_KEYS.DURATION_WARNING);
      localStorage.removeItem(CartTimerElement.STORAGE_KEYS.MODAL_SHOWN);
    } catch (e) {}
  }

  // ===== UTILITIES =====

  _getRemainingSeconds() {
    if (!this.startTime) return 0;
    const elapsed = Math.floor((Date.now() - this.startTime) / 1000);
    return Math.max(0, this.durationSeconds - elapsed);
  }

  _formatTime(totalSeconds) {
    return {
      minutes: Math.floor(totalSeconds / 60),
      seconds: totalSeconds % 60
    };
  }

  _cleanup() {
    this.stopTimer();

    if (this.cartEventListener) {
      document.documentElement.removeEventListener('cart:change', this.cartEventListener);
      this.cartEventListener = null;
    }
  }
}

if (!window.customElements.get('cart-timer')) {
  window.customElements.define('cart-timer', CartTimerElement);
}

// Cart Timer Display for Header - Refactored with comprehensive error handling
class CartTimerDisplayElement extends HTMLElement {
  // Constants
  static STORAGE_KEYS = {
    START_TIME: 'cart_timer_start',
    DURATION: 'cart_timer_duration',
    DURATION_WARNING: 'cart_timer_duration_warning'
  };

  static DEFAULTS = {
    UPDATE_INTERVAL_MS: 1000,
    WARNING_THRESHOLD_RATIO: 6 // Show warning when remaining time <= duration/6 (fallback if no duration_warning)
  };

  constructor() {
    super();
    this.interval = null;
    this.cartEventListener = null;
    this.lastDisplayValue = null; // Avoid unnecessary DOM updates
  }

  connectedCallback() {
    try {
      // Initial update
      this.updateDisplay();

      // Start update interval
      this.startUpdateInterval();

      // Listen to cart changes
      this.setupCartListener();
    } catch (error) {
      this._logError('Failed to initialize CartTimerDisplay', error);
    }
  }

  disconnectedCallback() {
    try {
      this._cleanup();
    } catch (error) {
      this._logError('Error during disconnection', error);
    }
  }

  // ===== INITIALIZATION METHODS =====

  startUpdateInterval() {
    try {
      this.interval = setInterval(() => {
        try {
          this.updateDisplay();
        } catch (error) {
          this._logError('Error in update interval', error);
        }
      }, CartTimerDisplayElement.DEFAULTS.UPDATE_INTERVAL_MS);
    } catch (error) {
      this._logError('Error starting update interval', error);
    }
  }

  setupCartListener() {
    try {
      this.cartEventListener = (event) => {
        try {
          if (event.detail && event.detail.cart) {
            this.updateDisplay();
          }
        } catch (error) {
          this._logError('Error handling cart change', error);
        }
      };

      document.documentElement.addEventListener('cart:change', this.cartEventListener);
    } catch (error) {
      this._logError('Error setting up cart listener', error);
    }
  }

  // ===== DISPLAY METHODS =====

  updateDisplay() {
    try {
      const timerState = this._loadTimerState();

      if (!timerState) {
        this._hideDisplay();
        return;
      }

      const { startTime, duration, durationWarning } = timerState;
      const remaining = this._calculateRemaining(startTime, duration);

      if (remaining <= 0) {
        this._hideDisplay();
        return;
      }

      this._showDisplay(remaining, duration, durationWarning);
    } catch (error) {
      this._logError('Error updating display', error);
      this._hideDisplay();
    }
  }

  _showDisplay(remainingSeconds, totalDuration, durationWarning) {
    try {
      const { minutes, seconds } = this._formatTime(remainingSeconds);
      const displayValue = `${minutes}:${seconds.toString().padStart(2, '0')}`;

      // Only update DOM if value changed
      if (this.lastDisplayValue !== displayValue) {
        this.textContent = displayValue;
        this.lastDisplayValue = displayValue;
      }

      // Show element if hidden
      if (this.hidden) {
        this.hidden = false;
      }

      // Toggle warning class - use durationWarning if available, otherwise fall back to ratio
      let shouldWarn;
      if (durationWarning && durationWarning > 0) {
        // Use duration_warning from settings (in minutes, convert to seconds)
        shouldWarn = remainingSeconds <= durationWarning * 60;
      } else {
        // Fallback to ratio-based warning
        shouldWarn = remainingSeconds <= totalDuration / CartTimerDisplayElement.DEFAULTS.WARNING_THRESHOLD_RATIO;
      }

      const hasWarning = this.classList.contains('header__cart-timer--warning');

      if (shouldWarn !== hasWarning) {
        this.classList.toggle('header__cart-timer--warning', shouldWarn);
      }
    } catch (error) {
      this._logError('Error showing display', error);
    }
  }

  _hideDisplay() {
    try {
      if (!this.hidden) {
        this.hidden = true;
        this.lastDisplayValue = null;
      }

      // Remove warning class when hidden
      if (this.classList.contains('header__cart-timer--warning')) {
        this.classList.remove('header__cart-timer--warning');
      }
    } catch (error) {
      this._logError('Error hiding display', error);
    }
  }

  // ===== STORAGE METHODS =====

  _loadTimerState() {
    try {
      const startTime = localStorage.getItem(CartTimerDisplayElement.STORAGE_KEYS.START_TIME);
      const duration = localStorage.getItem(CartTimerDisplayElement.STORAGE_KEYS.DURATION);
      const durationWarning = localStorage.getItem(CartTimerDisplayElement.STORAGE_KEYS.DURATION_WARNING);

      if (!startTime || !duration) {
        return null;
      }

      const parsedStartTime = parseInt(startTime, 10);
      const parsedDuration = parseInt(duration, 10);
      const parsedDurationWarning = durationWarning ? parseInt(durationWarning, 10) : 0;

      if (isNaN(parsedStartTime) || isNaN(parsedDuration)) {
        this._logError('Invalid timer state in storage', { startTime, duration });
        return null;
      }

      if (parsedStartTime <= 0 || parsedDuration <= 0) {
        this._logError('Invalid timer values', { parsedStartTime, parsedDuration });
        return null;
      }

      return {
        startTime: parsedStartTime,
        duration: parsedDuration,
        durationWarning: parsedDurationWarning
      };
    } catch (error) {
      this._logError('Error loading timer state from localStorage', error);
      return null;
    }
  }

  // ===== UTILITY METHODS =====

  _calculateRemaining(startTime, duration) {
    try {
      const now = Date.now();
      const elapsed = Math.floor((now - startTime) / 1000);
      return Math.max(0, duration - elapsed);
    } catch (error) {
      this._logError('Error calculating remaining time', error);
      return 0;
    }
  }

  _formatTime(totalSeconds) {
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return { minutes, seconds };
  }

  _cleanup() {
    // Stop interval
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }

    // Remove event listener
    if (this.cartEventListener) {
      document.documentElement.removeEventListener('cart:change', this.cartEventListener);
      this.cartEventListener = null;
    }

    // Reset state
    this.lastDisplayValue = null;
  }

  _logError(message, error = null) {
    console.error(`[CartTimerDisplay] ${message}`, error || '');
  }
}

if (!window.customElements.get('cart-timer-display')) {
  window.customElements.define('cart-timer-display', CartTimerDisplayElement);
}

// Zoom au survol des images produit - Desktop uniquement
(function () {
  if (!window.matchMedia('(pointer: fine) and (min-width: 1000px)').matches) {
    return;
  }

  function initProductGalleryZoom() {
    const productGallery = document.querySelector('product-gallery');
    if (!productGallery) return;

    const mediaElements = productGallery.querySelectorAll('.product-gallery__media[data-media-type="image"]');

    mediaElements.forEach(media => {
      const img = media.querySelector('img');
      if (!img) return;

      media.addEventListener('mousemove', (e) => {
        const rect = media.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width) * 100;
        const y = ((e.clientY - rect.top) / rect.height) * 100;
        img.style.transformOrigin = `${x}% ${y}%`;
      });

      media.addEventListener('mouseleave', () => {
        img.style.transformOrigin = 'center center';
      });
    });
  }

  // Initialiser au chargement du DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductGalleryZoom, { once: true });
  } else {
    initProductGalleryZoom();
  }

  // Réinitialiser après les mises à jour de section Shopify
  document.addEventListener('shopify:section:load', initProductGalleryZoom);
  document.addEventListener('shopify:section:select', initProductGalleryZoom);
})();

// Back in Stock Form Component
class BackInStockForm extends HTMLElement {
  constructor() {
    super();
    this.isSubmitting = false;
  }

  connectedCallback() {
    this.productId = this.getAttribute('product-id');
    this.variantId = this.getAttribute('variant-id');
    this.productTitle = this.getAttribute('product-title');

    // Ajouter l'event listener sur le bouton de soumission
    const submitButton = this.querySelector('button[name="submit-back-in-stock"]');
    if (submitButton) {
      submitButton.addEventListener('click', (e) => this.handleSubmit(e));
    }
  }

  async handleSubmit(event) {
    event.preventDefault();

    if (this.isSubmitting) {
      return;
    }

    const emailInput = this.querySelector('input[name="email"]');
    if (!emailInput) {
      this.showError('Une erreur est survenue. Veuillez réessayer.');
      return;
    }

    const email = emailInput.value.trim();

    // Validation basique de l'email
    if (!email || !this.isValidEmail(email)) {
      this.showError(window.themeVariables?.strings?.back_in_stock?.error_invalid_email || 'Veuillez entrer une adresse email valide.');
      return;
    }

    this.isSubmitting = true;
    const submitButton = this.querySelector('button[name="submit-back-in-stock"]');

    try {
      // Désactiver le bouton et montrer un état de chargement
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent = window.themeVariables?.strings?.back_in_stock?.submitting || 'Envoi...';
      }

      // Envoyer via le formulaire de contact Shopify
      const formData = new FormData();
      formData.append('contact[email]', email);
      formData.append('contact[subject]', 'Alerte de retour en stock');
      formData.append('contact[body]', `Je souhaite être notifié(e) lorsque le produit "${this.productTitle}" (Variant ID: ${this.variantId}) sera de nouveau disponible.`);

      const response = await fetch('/contact', {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json'
        }
      });

      if (response.ok || response.status === 303) {
        // Succès - fermer la modal et afficher une notification
        this.showSuccessToast();
        this.closeModal();
        this.resetForm();
      } else {
        throw new Error('Erreur lors de l\'envoi');
      }
    } catch (error) {
      console.error('[BackInStockForm] Error:', error);
      this.showError(window.themeVariables?.strings?.back_in_stock?.error_general || 'Une erreur est survenue. Veuillez réessayer.');
    } finally {
      this.isSubmitting = false;
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.textContent = window.themeVariables?.strings?.back_in_stock?.submit_button || 'Me notifier';
      }
    }
  }

  isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  showError(message) {
    const errorContainer = this.querySelector('.back-in-stock-form__error');
    const errorText = errorContainer?.querySelector('p');

    if (errorContainer && errorText) {
      errorText.textContent = message;
      errorContainer.hidden = false;

      // Masquer l'erreur après 5 secondes
      setTimeout(() => {
        errorContainer.hidden = true;
      }, 5000);
    }
  }

  showSuccessToast() {
    try {
      // Utiliser le système de toast existant du thème Stretch
      const successMessage = window.themeVariables?.strings?.back_in_stock?.success_message ||
        'Merci ! Nous vous préviendrons dès que ce produit sera disponible.';

      // Créer un event custom pour le toast (utilise l'événement "toast:show" du thème)
      document.dispatchEvent(
        new CustomEvent('toast:show', {
          bubbles: true,
          detail: {
            message: successMessage
          }
        })
      );
    } catch (error) {
      console.error('[BackInStockForm] Error showing toast:', error);
    }
  }

  closeModal() {
    try {
      const modal = this.closest('x-modal');
      if (modal) {
        modal.removeAttribute('open');
      }
    } catch (error) {
      console.error('[BackInStockForm] Error closing modal:', error);
    }
  }

  resetForm() {
    const emailInput = this.querySelector('input[name="email"]');
    if (emailInput) {
      emailInput.value = '';
    }
    const errorContainer = this.querySelector('.back-in-stock-form__error');
    if (errorContainer) {
      errorContainer.hidden = true;
    }
  }
}

if (!window.customElements.get('back-in-stock-form')) {
  window.customElements.define('back-in-stock-form', BackInStockForm);
}